var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResellPartners(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12.5L16.328 14.672C15.5779 15.4219 14.5607 15.8432 13.5 15.8432C12.4393 15.8432 11.4221 15.4219 10.672 14.672L10.5 14.5L15.429 9.57105C16.7552 8.24519 18.5537 7.50037 20.429 7.50037C22.3043 7.50037 24.1028 8.24519 25.429 9.57105V9.57105C26.5427 10.6849 27.2528 12.1385 27.4468 13.7016C27.6408 15.2647 27.3076 16.8478 26.5 18.2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.766 15.766L23.379 19.379C23.9414 19.9416 24.2574 20.7045 24.2574 21.5C24.2574 22.2955 23.9414 23.0584 23.379 23.621L21.743 25.257C21.1858 25.8143 20.5244 26.2563 19.7963 26.5579C19.0683 26.8595 18.288 27.0147 17.5 27.0147C16.712 27.0147 15.9317 26.8595 15.2037 26.5579C14.4756 26.2563 13.8142 25.8143 13.257 25.257L7.571 19.571C6.24515 18.2448 5.50032 16.4463 5.50032 14.571C5.50032 12.6957 6.24515 10.8972 7.571 9.571V9.571C8.87824 8.26011 10.6488 7.51619 12.5 7.5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.891 24.109L19 20.219",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.013 26.465L16.383 22.835",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResellPartners);
export default __webpack_public_path__ + "static/media/Resell-Partners.a8397aee9f7fb7327adfbb520e7bdae6.svg";
export { ForwardRef as ReactComponent };